import React from 'react'
import { ProductSummaryContainer, DetailsSummaryItem } from './styles'
import {
  DetailsSummaryContent,
  DetailsSummaryHeading
} from '../TopicsDetailComponent/styles'
import Markdown from '../../../../../common/components/markdown'

const ProductSummary = ({
  summaries,
  performScroll
}) => (
  <ProductSummaryContainer data-testid="product-summary">
    {summaries.map((topic) => (
      <DetailsSummaryItem key={topic.id} data-testid={topic.id}>
        <DetailsSummaryHeading
          data-testid={topic.title}
          onClick={() => {
            performScroll(topic.title)
          }}
        >
          {`${topic.title} Summary`}
        </DetailsSummaryHeading>
        <DetailsSummaryContent>
          <Markdown>
            {topic.summary}
          </Markdown>
        </DetailsSummaryContent>
      </DetailsSummaryItem>
    ))}
  </ProductSummaryContainer>
)

export default ProductSummary
